export default {
  // get snackbar store data
  getSnackbarData(state) {
    let snackbarData = {
      isOpen: state.showSnackbar,
      message: state.snackBarMessage,
      type: state.snackBarType,
    };
    return snackbarData;
  },
  isLocalEnv: () => window.location.href.includes("localhost"),
  domain: (state, getters) => {
    if (getters.isLocalEnv) {
      return "hrapp"; // local domain name
    } else {
      let domains = ["hrapp", "cannyhr"];
      let url = window.location.href;
      let urlNoProtocol = url.replace(/^https?:\/\//i, "");
      let domain = urlNoProtocol.split(".");
      domain = domain[1];
      if (domains.includes(domain)) return domain;
      else return "hrapp";
    }
  },
};
